// extracted by mini-css-extract-plugin
export default {"MaterialTruckDetailsContainer":"MaterialTruckDetails_MaterialTruckDetailsContainer__S0pLS","BidToolHeader":"MaterialTruckDetails_BidToolHeader__7Hr9C"};